<template>
  <form id="edit_channel_form">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">افزودن کانال</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="form-group">
          <label>نام کانال(انگلیسی)</label>
          <input
            type="text"
            name="slug"
            v-model="form.slug"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>نام کانال</label>
          <input
            type="text"
            name="title"
            v-model="form.title"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label>تصویر</label>
          <div class="custom-file">
            <input
              type="file"
              accept="image/*"
              class="custom-file-input"
              id="photo"
              @change="photoChanged"
            />
            <label class="custom-file-label" for="photo">{{ photo }}</label>
          </div>
        </div>

        <div class="form-group">
          <label>بنر</label>
          <div class="custom-file">
            <input
              type="file"
              accept="image/*"
              class="custom-file-input"
              id="banner"
              @change="bannerChanged"
            />
            <label class="custom-file-label" for="banner">{{ banner }}</label>
          </div>
        </div>

        <div class="form-group">
          <label>درباره کانال</label>
          <textarea
            name="about"
            v-model="form.about"
            class="form-control"
            rows="6"
          ></textarea>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>وبسایت</label>
              <input
                type="text"
                name="website"
                v-model="form.links.website"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>اینستاگرام</label>
              <input
                type="text"
                name="instagram"
                v-model="form.links.instagram"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>واتساپ</label>
              <input
                type="text"
                name="whatsapp"
                v-model="form.links.whatsapp"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>تلگرام</label>
              <input
                type="text"
                name="telegram"
                v-model="form.links.telegram"
                class="form-control"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_CHANNEL,
  UPDATE_CHANNEL,
  UPDATE_CHANNEL_BANNER,
  UPDATE_CHANNEL_PHOTO
} from "@/core/services/store/channels.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";

export default {
  name: "channels-edit",
  props: ["id"],
  data() {
    return {
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      tinyMceOptions: {
        menubar: false,
        directionality: "rtl"
      },
      form: {
        slug: "",
        title: "",
        about: "",
        links: {}
      },
      photo: "",
      banner: ""
    };
  },
  mounted() {
    this.getChannel();
    this.eventHub.$on("edit-channel-event", this.save);

    this.fv = formValidation(document.getElementById("edit_channel_form"), {
      fields: {
        title: {
          validators: {
            notEmpty: {
              message: "نام صحیح نیست"
            },
            stringLength: {
              min: 1,
              max: 128,
              message: "نام صحیح نیست"
            }
          }
        },
        slug: {
          validators: {
            notEmpty: {
              message: "نام انگلیسی صحیح نیست"
            },
            regexp: {
              regexp: /^(?!\d)(?!.*-.*-)(?!.*-$)(?!-)[a-zA-Z0-9-]{6,20}$/i,
              message: "نام انگلیسی صحیح نیست"
            },
            stringLength: {
              min: 1,
              max: 128,
              message: "نام انگلیسی صحیح نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  beforeDestroy() {
    this.eventHub.$off("edit-channel-event");
    document.getElementById("edit-channel-btn").disabled = false;
  },
  computed: {
    ...mapGetters(["channel", "channelPhotoProgress", "channelBannerProgress"])
  },
  methods: {
    getChannel() {
      this.loaded = false;

      this.$store
        .dispatch(FETCH_CHANNEL, this.$route.params.id)
        .then(() => {
          this.loaded = true;
          this.form = {
            id: this.channel.id,
            slug: this.channel.slug,
            title: this.channel.title,
            about: this.channel.about,
            links: {
              website: this.channel.links.website,
              instagram: this.channel.links.instagram,
              whatsapp: this.channel.links.whatsapp,
              telegram: this.channel.links.telegram
            }
          };

          this.photo = this.channel.files["photo"];
          this.banner = this.channel.files["banner"];
          this.setBreadcrumbs();
          this.setActions();
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    setBreadcrumbs() {
      let items = [];
      items.push({ title: "کانال‌ها", route: { name: "channels-index" } });
      items.push({ title: this.channel.title });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      let channelsRouteName = "channels-index";

      if (this.isCompany) {
        channelsRouteName = "company-channels-index";
      }

      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "ذخیره",
            event: "edit-channel-event",
            class: "btn-primary",
            id: "edit-channel-btn"
          }
        ],
        links: [
          {
            name: "بازگشت",
            to: { name: channelsRouteName }
          }
        ]
      });
    },
    save() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("edit-channel-btn");
          this.disableBtn(submitBtn);

          this.$store
            .dispatch(UPDATE_CHANNEL, this.form)
            .then(() => {
              this.$router.push({
                name: "channels-show",
                params: { id: this.$route.params.id }
              });
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    },
    photoChanged(e) {
      if (e.target.files && e.target.files[0]) {
        e.target.nextElementSibling.innerHTML = e.target.files[0].name;
        e.target.nextElementSibling.classList.add("selected");

        let submitBtn = document.getElementById("edit-channel-btn");
        this.disableBtn(submitBtn);

        this.$store
          .dispatch(UPDATE_CHANNEL_PHOTO, {
            channel: this.channel.id,
            file: e.target.files[0]
          })
          .then(name => {
            this.photo = name;
            this.enableBtn(submitBtn);
          })
          .catch(() => {
            this.enableBtn(submitBtn);
          });
      } else {
        e.target.nextElementSibling.innerHTML = "";
        e.target.nextElementSibling.classList.remove("selected");
      }
    },
    bannerChanged(e) {
      if (e.target.files && e.target.files[0]) {
        e.target.nextElementSibling.innerHTML = e.target.files[0].name;
        e.target.nextElementSibling.classList.add("selected");

        let submitBtn = document.getElementById("edit-channel-btn");
        this.disableBtn(submitBtn);

        this.$store
          .dispatch(UPDATE_CHANNEL_BANNER, {
            channel: this.channel.id,
            file: e.target.files[0]
          })
          .then(name => {
            this.banner = name;
            this.enableBtn(submitBtn);
          })
          .catch(() => {
            this.enableBtn(submitBtn);
          });
      } else {
        e.target.nextElementSibling.innerHTML = "";
        e.target.nextElementSibling.classList.remove("selected");
      }
    }
  }
};
</script>
